// extracted by mini-css-extract-plugin
export default {"projectContainer":"Projects_projectContainer__BI27D","projectTitle":"Projects_projectTitle__iBVPN","projectBox":"Projects_projectBox__3GhPa"};